import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const createBroadBand = (_, params) => {
  return Api(endPoints.createBroadBand, params, requestType.POST);
};

const updateBroadBand = (id, params) => {
  return Api(`${endPoints.updateBroadBand}/${id}`, params, requestType.PUT);
};
const getBroadbandForWeb = (params) => {
  return Api(
    `${endPoints.getBroadbandForWeb}?tarrif=${params}`,
    null,
    requestType.GET
  );
};

const getAllBroadbandByType = (type) => {
  if (!type) return;

  return Api(
    `${endPoints.getAllBroadbandByType}?type=${type}`,
    null,
    requestType.GET
  );
};

const getAdditionalServiceByType = (type) => {
  if (!type) return;

  return Api(
    `${endPoints.getAdditionalServiceByType}?type=${type}`,
    null,
    requestType.GET
  );
};

export {
  createBroadBand,
  updateBroadBand,
  getAllBroadbandByType,
  getAdditionalServiceByType,
  getBroadbandForWeb,
};
